import React from 'react';

export const LinkedInLogo: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
    <path
      fill='#fff'
      d='M8.294 9.882H5.647v8.47h2.647v-8.47zm.238-2.912a1.525 1.525 0 00-1.514-1.535h-.047a1.535 1.535 0 100 3.07 1.525 1.525 0 001.561-1.487V6.97zm9.821 6.237c0-2.547-1.62-3.537-3.23-3.537a3.017 3.017 0 00-2.678 1.366h-.074V9.882H9.882v8.47h2.647v-4.505a1.758 1.758 0 011.589-1.895h.1c.842 0 1.467.53 1.467 1.864v4.537h2.647l.021-5.146z'
    ></path>
    <path
      fill='#0A66C2'
      d='M21 4.324v15.353A1.323 1.323 0 0119.677 21H4.324A1.323 1.323 0 013 19.677V4.324A1.324 1.324 0 014.324 3h15.353A1.323 1.323 0 0121 4.324zM8.294 9.882H5.647v8.47h2.647v-8.47zm.238-2.911a1.525 1.525 0 00-1.514-1.536h-.047a1.535 1.535 0 000 3.07 1.525 1.525 0 001.561-1.487v-.047zm9.82 6.236c0-2.546-1.62-3.536-3.229-3.536a3.017 3.017 0 00-2.678 1.366h-.074V9.882H9.882v8.47h2.647v-4.504a1.757 1.757 0 011.589-1.896h.1c.842 0 1.467.53 1.467 1.864v4.537h2.647l.02-5.146z'
    ></path>
  </svg>
);
